"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiGroup = _interopRequireDefault(require("./ApiGroup"));
class Network extends _ApiGroup.default {
  /**
   * Get the latest block's data for a network.
   *
   * @param {string | number} network
   */
  latestBlock(network) {
    return this.request({
      url: `/contracts/network/${network}/block/latest`
    }).then(response => response.data.data);
  }

  /**
   * Get data for a block.
   *
   * @param {string | number} network
   * @param {number} number
   */
  getBlock(network, number) {
    return this.request({
      url: `/contracts/network/${network}/block/${number}`
    }).then(response => response.data.data);
  }
}
var _default = exports.default = Network;
//# sourceMappingURL=Network.js.map